// Auto-generated per-query builders for SoftwarePart
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { SoftwarePartReadAPI, SoftwarePartWriteAPI, SoftwarePartReadAPISchema, SoftwarePartWriteAPISchema } from '../types/softwarepart';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, ContainsSoftwarePart, HasAttribute, HasAttributeValue, HasDerivedValue, HasInterfacePort, HasRequirement, Mentions, OwnedByUser, PartBindsInterfacePort, RFLPAllocation } from '../../relationships/relationship';

import { Project } from './project';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';
import { LogicalPart } from './logicalpart';
import { User } from '../../base/api/user';
import { Requirement } from './requirement';
import { InterfacePort } from './interfaceport';





// Builder chain for query: rflp-software-part-by-id

export interface RflpSoftwarePartByIdBuilder_0 {
  get(id: string): RflpSoftwarePartByIdBuilder_1;
  filter(conditions: { id: string }): RflpSoftwarePartByIdBuilder_1;
}

export interface RflpSoftwarePartByIdBuilder_1 {
  all(): Promise<SoftwarePart[]>;
  first(): Promise<SoftwarePart | null>;
  get(): Promise<SoftwarePart[]>;
  execute(): Promise<SoftwarePart[]>;
}


// Union of all query entry points
export type SoftwarePartQueryBuilder = RflpSoftwarePartByIdBuilder_0;

// Available query names for .setQuery()
export type SoftwarePartQueryNames = "rflp-software-part-by-id";

// Type narrowing for .setQuery()
export type SoftwarePartBuilderForQuery<Q extends SoftwarePartQueryNames> =
  Q extends "rflp-software-part-by-id" ? RflpSoftwarePartByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type SoftwarePartInstanceQueryResult<Q extends SoftwarePartQueryNames> =
  Q extends "rflp-software-part-by-id" ? RflpSoftwarePartByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-software-part-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends SoftwarePartQueryNames>(queryName: Q): SoftwarePartBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface SoftwarePart extends Partial<SoftwarePartReadAPI> {}
export class SoftwarePart extends NeoNodeBase<SoftwarePartReadAPI, SoftwarePartWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "SoftwarePart";
  static readonly readSchema = SoftwarePartReadAPISchema;
  static readonly writeSchema = SoftwarePartWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    allocation_sources: { target: "LogicalPart", cardinality: "many", isParent: false, relClass: "RFLPAllocation", direction: "in" },
    responsible_user: { target: "User", cardinality: "one", isParent: false, relClass: "OwnedByUser", direction: "out" },
    requirements: { target: "Requirement", cardinality: "many", isParent: false, relClass: "HasRequirement", direction: "out" },
    interface_ports: { target: "InterfacePort", cardinality: "many", isParent: false, relClass: "HasInterfacePort", direction: "out" },
    bound_interface_ports: { target: "InterfacePort", cardinality: "many", isParent: false, relClass: "PartBindsInterfacePort", direction: "out" },
    parent: { target: "Project", cardinality: "one", isParent: true, relClass: "ContainsSoftwarePart", direction: "in" },
    children: { target: "SoftwarePart", cardinality: "many", isParent: false, relClass: "ContainsSoftwarePart", direction: "out" },
  };

  protected get modelName(): string {
    return 'SoftwarePart';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return SoftwarePart.label;
  }


  constructor(data: Partial<SoftwarePartWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: SoftwarePartReadAPI, loadContext?: Record<string, any>): SoftwarePart {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { requirements, interface_ports, bound_interface_ports, parent, children, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, allocation_sources, responsible_user, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = SoftwarePartReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, requirements: requirements, interface_ports: interface_ports, bound_interface_ports: bound_interface_ports, parent: parent, children: children, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions, allocation_sources: allocation_sources, responsible_user: responsible_user };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return SoftwarePart.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'requirements', 'Requirement', ModelRegistry);
    loadManyRelationship(processed, 'interface_ports', 'InterfacePort', ModelRegistry);
    loadManyRelationship(processed, 'bound_interface_ports', 'InterfacePort', ModelRegistry);
    loadManyRelationship(processed, 'parent', 'Project', ModelRegistry);
    loadManyRelationship(processed, 'children', 'SoftwarePart', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    loadManyRelationship(processed, 'allocation_sources', 'LogicalPart', ModelRegistry);
    loadOneRelationship(processed, 'responsible_user', 'User', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new SoftwarePart(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): SoftwarePartQueryBuilder {
    return new QueryBuilderImpl('SoftwarePart').filter(conditions) as any;
  }

  static all(): SoftwarePartQueryBuilder {
    return new QueryBuilderImpl('SoftwarePart') as any;
  }

  static async first(): Promise<SoftwarePart | null> {
    const results = await new QueryBuilderImpl('SoftwarePart').execute();
    return results[0] || null;
  }


  static setQuery<Q extends SoftwarePartQueryNames>(queryName: Q): SoftwarePartBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('SoftwarePart');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends SoftwarePartQueryNames>(queryName: Q): SoftwarePartInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = SoftwarePart.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const softwarepart = await SoftwarePart.get(id).first();
   * await softwarepart.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await softwarepart.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'parent' - Python ORM style (cached)
  get parent(): RelationshipManager<this, Project> {
    return this.getOrCreateRelationshipManager('parent', () => {
      return new RelationshipManager(this, 'parent', 'many', ContainsSoftwarePart as typeof Relationship);
    });
  }

  // Relationship manager for 'children' - Python ORM style (cached)
  get children(): RelationshipManager<this, SoftwarePart> {
    return this.getOrCreateRelationshipManager('children', () => {
      return new RelationshipManager(this, 'children', 'many', ContainsSoftwarePart as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'allocation_sources' - Python ORM style (cached)
  get allocation_sources(): RelationshipManager<this, LogicalPart> {
    return this.getOrCreateRelationshipManager('allocation_sources', () => {
      return new RelationshipManager(this, 'allocation_sources', 'many', RFLPAllocation as typeof Relationship);
    });
  }

  // Relationship manager for 'responsible_user' - Python ORM style (cached)
  get responsible_user(): RelationshipManager<this, User> {
    return this.getOrCreateRelationshipManager('responsible_user', () => {
      return new RelationshipManager(this, 'responsible_user', 'one', OwnedByUser as typeof Relationship);
    });
  }

  // Relationship manager for 'requirements' - Python ORM style (cached)
  get requirements(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('requirements', () => {
      return new RelationshipManager(this, 'requirements', 'many', HasRequirement as typeof Relationship);
    });
  }

  // Relationship manager for 'interface_ports' - Python ORM style (cached)
  get interface_ports(): RelationshipManager<this, InterfacePort> {
    return this.getOrCreateRelationshipManager('interface_ports', () => {
      return new RelationshipManager(this, 'interface_ports', 'many', HasInterfacePort as typeof Relationship);
    });
  }

  // Relationship manager for 'bound_interface_ports' - Python ORM style (cached)
  get bound_interface_ports(): RelationshipManager<this, InterfacePort> {
    return this.getOrCreateRelationshipManager('bound_interface_ports', () => {
      return new RelationshipManager(this, 'bound_interface_ports', 'many', PartBindsInterfacePort as typeof Relationship);
    });
  }

}
